import React from 'react'
import { formatDateStandard } from '../../../../global/formatters/string-formatter'

function CapitalGainsCalendarYearDistributions({ calendarYearDistributions }) {
  return (
    <div className="Content u-paddingTop0" id="calendar-year-distributions">
      <h3 className="u-marginTop2gu">
        Calendar Year Distributions{' '}
        <span className="u-sm-block u-sm-paddingTop1gu">
          as of{' '}
          {formatDateStandard(
            calendarYearDistributions.calendarYearDistrAsOfDate
          )}
        </span>
      </h3>
      <div className="u-overflowX">
        <table className="Table Table--reversed Table--striped">
          <thead className="Table-head">
            <tr className="Table-row">
              <th className="Table-header u-alignMiddle"></th>
              {calendarYearDistributions.calendarYearDistrLabels.map(
                (label) => {
                  return (
                    <th
                      className="Table-header u-alignMiddle u-textRight"
                      key={label}
                    >
                      {label}
                    </th>
                  )
                }
              )}
            </tr>
          </thead>
          <tbody className="Table-body">
            {calendarYearDistributions.calendarYearDistributions.map(
              (detail, index) => {
                return (
                  <tr className="Table-row" key={detail.label + index}>
                    <td className="Table-cell">{detail.label}</td>
                    <td className="Table-cell u-textRight">{detail.ytd}</td>
                    <td className="Table-cell u-textRight">{detail.oneYear}</td>
                    <td className="Table-cell u-textRight">{detail.twoYear}</td>
                    <td className="Table-cell u-textRight">
                      {detail.threeYear}
                    </td>
                    <td className="Table-cell u-textRight">
                      {detail.fourYear}
                    </td>
                    <td className="Table-cell u-textRight">
                      {detail.fiveYear}
                    </td>
                  </tr>
                )
              }
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default CapitalGainsCalendarYearDistributions
